// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__1llOI","sendOtp":"AuthorizeToLogin_sendOtp__ac-0o"};